import { Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import { httpService } from "../../../../services/httpService.service";
import ContractRangeSelectors from "../../../components/ContractRamgeSelectors/ContractRangeSelectors";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const Option = Select;

const Filters = ({ filters, setFilters, implementingPartner = false }) => {
  const [form] = Form.useForm();
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [implementingPartners, setImplementingPartners] = useState([]);
  const isGuestShare = process.env.REACT_APP_API_IS_GUEST;
  const [range, setRange] = useState({
    year: undefined,
    month: undefined,
    quarter: undefined,
  });

  useEffect(() => {
    fetchCountries();
    const contractId = localStorage.getItem("currentContractId");
    fetchImplementingPartners(contractId);
  }, []);

  const fetchImplementingPartners = (contractId) => {
    if (!isGuestShare) {
      httpService.get(
        `/api/ImplementingPartner/getAllImplementingPartners?ContractId=${contractId}&IgnorePagination=true`,
        (res) => {
          setImplementingPartners(res.data);
        },
        (err) => {
          // console.log(err);
        }
      );
    }
  };

  const fetchCountries = () => {
    const contractId = localStorage.getItem("currentContractId");
    httpService.get(
      `/api/GeoData/getCountriesOfContract?contractId=${contractId}`,
      (res) => {
        setCountries(res.data);
      },
      (err) => {
        // console.log(err);
      }
    );
  };

  const fetchStates = (countryName) => {
    httpService.get(
      `/api/Site/getStatesOfSiteVisits?country=${countryName}`,
      (res) => {
        setStates(res.data);
      },
      (err) => {
        // console.log(err);
      }
    );
  };

  const handleCountryChange = (country) => {
    form.setFieldsValue({ state: 1 });

    const countryName = country.children;
    const countryId = country.value;
    if (countryId == 1) {
      setStates([]);
      setFilters({ ...filters, country: "" });
      return;
    }

    fetchStates(countryName);
    setFilters({ ...filters, country: countryName });
  };

  const handleStateChange = (state) => {
    if (state === 1) {
      setFilters({ ...filters, state: "" });
      return;
    }
    setFilters({ ...filters, state: state });
  };

  const handleRangeChange = (newValue) => {
    const { month, year } = newValue || {};

    const contractStart = dayjs
      .utc(localStorage.getItem("Contract-startDate"))
      .local();
    const contractEnd = dayjs
      .utc(localStorage.getItem("Contract-endDate"))
      .local();

    let startDate, endDate;

    if (!year) {
      startDate = contractStart;
      endDate = contractEnd;
    } else if (year && !month) {
      startDate = dayjs().year(Number(year)).startOf("year");
      endDate = dayjs().year(Number(year)).endOf("year");

      if (startDate.isBefore(contractStart)) startDate = contractStart;
      if (endDate.isAfter(contractEnd)) endDate = contractEnd;
    } else if (year && month != null) {
      const monthIndex = Number(month) - 1;
      startDate = dayjs().year(Number(year)).month(monthIndex).startOf("month");
      endDate = dayjs().year(Number(year)).month(monthIndex).endOf("month");

      if (startDate.isBefore(contractStart)) startDate = contractStart;
      if (endDate.isAfter(contractEnd)) endDate = contractEnd;
    }

    setFilters((prev) => ({
      ...prev,
      startDate,
      endDate,
    }));

    setRange(newValue);
  };

  return (
    <Form form={form} className="d-flex flex-row flex-wrap gap-2">
      {implementingPartner && (
        <Form.Item
          name="implementingPartner"
          className="m-0"
          style={{ width: 200 }}
        >
          <Select
            value={1}
            onChange={(implementingPartnerId) =>
              setFilters({
                ...filters,
                implementingPartnerId:
                  implementingPartnerId !== 1 ? implementingPartnerId : "",
              })
            }
            defaultValue={1}
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().startsWith(input.toLowerCase())
            }
          >
            <Option key={1} value={1}>
              All Implementing Partners
            </Option>
            {implementingPartners.map((partner) => (
              <Option key={partner.id} value={partner.id}>
                {partner.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item name="country" className="  m-0" style={{ width: 200 }}>
        <Select
          onChange={(countryName, country) => handleCountryChange(country)}
          defaultValue={1}
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().startsWith(input.toLowerCase())
          }
        >
          <Option key={1} value={1}>
            All Countries
          </Option>
          {countries.map((country) => (
            <Option key={country.id} value={country.id}>
              {country.stateName}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {form.getFieldValue("country") !== 1 &&
        form.getFieldValue("country") !== undefined && (
          <Form.Item name="state" className=" m-0" style={{ width: 200 }}>
            <Select
              onChange={handleStateChange}
              defaultValue={1}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              <Option key={1} value={1}>
                All States
              </Option>
              {states.map((state) => (
                <Option key={state} value={state}>
                  {state}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
      <ContractRangeSelectors value={range} onChange={handleRangeChange} />
    </Form>
  );
};

export default Filters;
